export interface ProfessionAliasModel {
  id: string;
  name: string;
  code: string;
  type: ProfessionAliasType;
  profession: string;
  profession_code: string;
}

export enum ProfessionAliasType {
  unknown = 0,
  primary = 1,
  synonym = 2,
  specialiazation = 3,
}
